export default "__VITE_ASSET__20f38230__"